module.exports = __webpack_public_path__ + "img/rule30.png";